import React, { FC } from "react";
import { RouteProps } from "react-router";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/";
import { PageLoading } from "../page-loading";

export const AuthenticatedRoute: FC<RouteProps> = ({ element }) => {
  const { error, isLoading, isAuthenticated } = useAuth();
  const { pathname, search, hash } = useLocation();

  if (isLoading || error) {
    return <PageLoading loading={isLoading} error={error} />;
  }

  return isAuthenticated ? (
    <>{element}</>
  ) : (
    <Navigate
      to="/login"
      state={{ returnTo: `${pathname}${search ? `?${search}` : ""}${hash ? `#${hash}` : ""}` }}
    />
  );
};
